export const UNKNOWN_ERROR = 99999;